import { Box, Input, useToast } from '@chakra-ui/react'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'

import { UserMenuItem } from '@/components/Menu/User/User'
import { usePoleasEssoxImport } from '@/hooks/usePoleasEssox'
import { faFileImport } from '@fortawesome/pro-light-svg-icons'

interface PoleasEssoxImportPayload {
  file: FileList
}

export const PoleasEssoxImportButton = () => {
  const methods = useForm<PoleasEssoxImportPayload>()
  const { reset, handleSubmit, register, getValues } = methods
  const toast = useToast()

  const { mutateAsync: importAsync, isPending } = usePoleasEssoxImport()


  const upload = async (values: PoleasEssoxImportPayload) => {
    const data = new FormData()
    data.append('file', values.file.item(0) as File)

    await importAsync({ data })
      .then((result) => {
        if (result.status == 200) {
          toast({
            title: 'Import se úspěšně provedl. Vznikly nabídky: ' + result.data.join(', '),
            status: 'success',
          })
        }
      })
      .catch((e) =>
        toast({
          title: e.error,
          description: <Box noOfLines={10} whiteSpace='pre'>
            {e.description}
          </Box>,
          status: 'error',
          isClosable: true,
          duration: null
        }),
      )

    reset()
  }

  const selectFile = () => {
    document.getElementById('fileInput')?.click()
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(upload)}>
        <Input
          id="fileInput"
          display="none"
          type="file"
          {...register('file', { onChange: () => upload(getValues()) })}
          multiple={false}
          accept=".xlsx,.csv"
        />
        <UserMenuItem label='Poleas - Import' onClick={selectFile} isLoading={isPending} icon={faFileImport}/>
      </form>
    </FormProvider>)
}